import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateAdminPost as createAdminPostApi } from "../services/AdminPostService";
import { formatDate } from "../utils/dateUtils";
import { useDispatch } from "react-redux";
import { setSuccessMessage } from "../slices/messageSlice";

const CreateAdminPost = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [timeRelease, setTimeRelease] = useState("");
  const [images, setImages] = useState([]); // File[]
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  // Convert files to base64
  const filesToBase64 = (files) => {
    return Promise.all(
      Array.from(files).map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      })
    );
  };

  const handleImageChange = (e) => {
    setImages(e.target.files);
  };

  function formatDateTimeLocalToApiFormat(dt) {
    if (!dt) return "";
    const [date, time] = dt.split("T");
    if (!date || !time) return dt;
    return `${date} ${time.length === 5 ? time + ":00" : time}`;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const base64Arr = await filesToBase64(images);
      const image64 = JSON.stringify(base64Arr);
      let formattedTimeRelease = timeRelease;
      if (timeRelease) {
        formattedTimeRelease = formatDateTimeLocalToApiFormat(timeRelease);
      }
      const res = await createAdminPostApi(
        title,
        content,
        formattedTimeRelease,
        image64.toString()
      );
      if (res && res.status_code == 200) {
        navigate(-1);
        dispatch(setSuccessMessage("Tạo bài viết thành công"));
      } else {
        setError(res?.message || "Tạo bài viết thất bại");
      }
    } catch (err) {
      setError("Có lỗi xảy ra khi tạo bài viết");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto p-4 rounded shadow mt-8 bg-white dark:bg-[#23272f]">
      <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-gray-100">
        Tạo bài viết admin
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block font-semibold mb-1 text-gray-800 dark:text-gray-200">
            Tiêu đề
          </label>
          <input
            type="text"
            className="w-full border border-gray-300 dark:border-gray-600 rounded px-3 py-2 bg-white dark:bg-[#23272f] text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block font-semibold mb-1 text-gray-800 dark:text-gray-200">
            Nội dung
          </label>
          <textarea
            className="w-full border border-gray-300 dark:border-gray-600 rounded px-3 py-2 bg-white dark:bg-[#23272f] text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
            rows={5}
          />
        </div>
        <div>
          <label className="block font-semibold mb-1 text-gray-800 dark:text-gray-200">
            Thời gian phát hành
          </label>
          <input
            type="datetime-local"
            className="w-full border border-gray-300 dark:border-gray-600 rounded px-3 py-2 bg-white dark:bg-[#23272f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={timeRelease}
            onChange={(e) => setTimeRelease(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block font-semibold mb-1 text-gray-800 dark:text-gray-200">
            Ảnh (có thể chọn nhiều)
          </label>
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={handleImageChange}
            className="block w-full text-gray-900 dark:text-gray-100 file:bg-blue-600 file:text-white file:rounded file:px-3 file:py-1 file:border-0 file:mr-2 dark:file:bg-blue-500 dark:file:text-white"
          />
        </div>
        {error && <div className="text-red-500 dark:text-red-400">{error}</div>}
        <div className="flex gap-2">
          <button
            type="submit"
            className="bg-blue-600 dark:bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700 dark:hover:bg-blue-600"
            disabled={loading}
          >
            {loading ? "Đang tạo..." : "Tạo bài viết"}
          </button>
          <button
            type="button"
            className="bg-gray-400 dark:bg-gray-700 text-white px-4 py-2 rounded hover:bg-gray-500 dark:hover:bg-gray-600"
            onClick={() => navigate(-1)}
          >
            Quay lại
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateAdminPost;
